import { store } from "@/web/components/state/store";
import ApiService from "@/pad/components/request/requestAdmin";
export const QUEEUE_DATA = 'QUEEUE_DATA';
export const QUEEUE_DATA_PASS = 'QUEEUE_DATA_PASS';
export const QUEEUE_DATA_COMPLETE = 'QUEEUE_DATA_COMPLETE';
export const QUEEUE_PYSICAL_DATA = 'QUEEUE_PYSICAL_DATA';
export const QUEEUE_PYSICAL_DATA_PASS = 'QUEEUE_PYSICAL_DATA_PASS';
export const QUEEUE_PYSICAL_DATA_COMPLETE = 'QUEEUE_PYSICAL_DATA_COMPLETE';
export const QUEEUE_COLECTION_DATA = 'QUEEUE_COLECTION_DATA';
export const QUEEUE_COLECTION_DATA_PASS = 'QUEEUE_COLECTION_DATA_PASS';
export const QUEEUE_COLECTION_DATA_COMPLETE = 'QUEEUE_COLECTION_DATA_COMPLETE';

export const queueQuery = async (url, param, dispatch) => {
  const result = await ApiService.get(url, param);
  return result;
};

export const queueDataService = async(url, param, dispatch) => {
    const result = await queueQuery(url, param);
    dispatch({ type: QUEEUE_DATA, queueData: [...result.data] });
    // store.dispatch({ type: QUEEUE_DATA, queueData: result.data });
    return result;
}